import { Segmented } from "antd";

interface NCDFilterSegmentedProps {
  name: string; // form field name
  onChange?: (val: string) => void;
}

const NCDFilterSegmented: React.FC<NCDFilterSegmentedProps> = ({
  name,
  onChange
}) => {
  const baseClasses =
  "flex flex-col items-center justify-center text-[8px] sm:text-[10px] font-medium";
  const containerClasses =
  "h-8 sm:h-9 rounded-md transition-all duration-200 hover:bg-gray-50";

  const options = [
  {
    label:
    <div
      className={`${baseClasses} ${containerClasses} w-[65px] sm:w-[75px]`}>
      
          <span className="leading-tight">Only</span>{" "}
          <span className="leading-tight font-semibold text-blue-600">DM</span>
        </div>,

    value: "only_dm"
  },
  {
    label:
    <div
      className={`${baseClasses} ${containerClasses} w-[65px] sm:w-[75px]`}>
      
          <span className="leading-tight">Only</span>{" "}
          <span className="leading-tight font-semibold text-red-600">HT</span>
        </div>,

    value: "only_ht"
  },
  {
    label:
    <div
      className={`${baseClasses} ${containerClasses} w-[75px] sm:w-[85px]`}>
      
          <span className="leading-tight font-semibold text-purple-600">
            DM & HT
          </span>
        </div>,

    value: "both_dm_and_ht"
  },
  {
    label:
    <div
      className={`${baseClasses} ${containerClasses} w-[60px] sm:w-[70px]`}>
      
          <span className="leading-tight font-semibold text-gray-600">
            Custom
          </span>
        </div>,

    value: "custom"
  }];

  return (
    <Segmented
      block
      defaultValue="custom"
      options={options}
      onChange={(val) => {
        if (onChange) onChange(val as string);
      }}
      className="mb-3"
      style={{
        backgroundColor: "#f8f9fa",
        borderRadius: "8px",
        padding: "2px",
        marginBottom: "13px"
      }} />);

};

export default NCDFilterSegmented;